/* ****************************************************************************
 * Legend for bubble-based visualizations
 * ***************************************************************************/
define(function(require) {
	var d3 = require('d3c');
	var d3wl = require('utils/d3-wl-util').default;
	var legendTooltip = require('modules/bubblelegend/BubbleLegendTooltip').sliderTooltip;
	var numFormat = require('utils/NumberFormat');

	return function(id, module, callback, tooltipClasses, tooltipHeight) {
		var legend = {
			id: id,
			initialized: false
		};
		var tooltip = null;
		var defaultTooltipClasses = 'forceWidth110';

		var maxFontSize = 8;
		var labelOffset = 4;
		var vOffset = 0;

		var container = '';
		var valType = 'int';
		var nodeSizeFactor = 1;
		var minVal = 0;
		var maxVal = 0;
		var minR = 0;
		var maxR = 0;
		var scale = 1;
		var active = true; // for geomap only

		var events = d3.dispatch('highlightNodes', 'dehighlightNodes', 'showTooltip');

		// add element containers
		legend.initialize = function(cont, svg, valueType, caption) {
			valType = valueType;
			container = cont;

			var legendContainer = svg
				.append('g')
				.attr('id', legend.id)
				.attr('class', 'bubble-legend');

			// background elements
			var legendBg = legendContainer
				.append('g')
				.attr('class', 'bubble-legend-bg');

			// max circle and text background
			var legendBgMax = legendBg
				.append('g')
				.attr('class', 'bubble-legend-max');

			legendBgMax
				.append('circle')
				.attr('class', 'bubble-legend-circle')
				.attr('r', 0);

			legendBgMax
				.append('text')
				.attr('class', 'bubble-legend-value')
				.attr('dy', -1);

			// min circle background
			var legendBgMin = legendBg
				.append('g')
				.attr('class', 'bubble-legend-min');

			legendBgMin
				.append('circle')
				.attr('class', 'bubble-legend-circle')
				.attr('r', 0);

			// legend caption text background
			legendBg
				.append('text')
				.attr('class', 'bubble-legend-label')
				.attr('dy', '.35em')
				.text(caption);

			// foreground elements
			var legendFg = legendContainer
				.append('g')
				.attr('class', 'bubble-legend-fg');

			// max circle and text foreground
			var legendFgMax = legendFg
				.append('g')
				.attr('class', 'bubble-legend-max')
				.on('mouseenter', function() {
					d3
						.select(this)
						.classed('hovered', true);

					events.call('highlightNodes', this, container, maxVal);
				})
				.on('mouseleave', function() {
					d3
						.select(this)
						.classed('hovered', false);

					events.call('dehighlightNodes');
				});

			legendFgMax
				.append('circle')
				.attr('class', 'bubble-legend-circle')
				.attr('r', 0);

			legendFgMax
				.append('text')
				.attr('class', 'bubble-legend-value')
				.attr('dy', -1);

			// -------------------------
			// highlighted node elements
			var legendNode = legendFg
				.append('g')
				.attr('class', 'bubble-legend-node');

			// highlighted node circle and text background
			var legendNodeBg = legendNode
				.append('g')
				.attr('class', 'bubble-legend-node-bg');

			legendNodeBg
				.append('circle')
				.attr('class', 'bubble-legend-circle')
				.attr('r', 0);

			legendNodeBg
				.append('text')
				.attr('class', 'bubble-legend-value')
				.attr('dy', -1);

			// highlighted node circle and text foreground
			var legendNodeFg = legendNode
				.append('g')
				.attr('class', 'bubble-legend-node-fg');

			legendNodeFg
				.append('circle')
				.attr('class', 'bubble-legend-circle')
				.attr('r', 0);

			legendNodeFg
				.append('text')
				.attr('class', 'bubble-legend-value')
				.attr('dy', -1);
			// -------------------------

			// min circle and text backround/foreground
			var legendFgMin = legendFg
				.append('g')
				.attr('class', 'bubble-legend-min')
				.on('mouseenter', function() {
					d3
						.select(this)
						.classed('hovered', true);

					events.call('highlightNodes', this, container, minVal);
				})
				.on('mouseleave', function() {
					d3
						.select(this)
						.classed('hovered', false);

					events.call('dehighlightNodes');
				});

			legendFgMin
				.append('circle')
				.attr('class', 'bubble-legend-circle')
				.attr('r', 0);

			legendFgMin
				.append('text')
				.attr('class', 'bubble-legend-value-bg')
				.attr('dy', -1);

			legendFgMin
				.append('text')
				.attr('class', 'bubble-legend-value')
				.attr('dy', -1);

			// legend caption text foreground
			legendFg
				.append('text')
				.attr('class', 'bubble-legend-label')
				.attr('dy', '.35em')
				.text(caption)
				.on('mouseenter', function() {
					d3
						.select(this)
						.classed('hovered', true);
				})
				.on('mouseleave', function() {
					d3
						.select(this)
						.classed('hovered', false);
				});

			d3
				.select('#' + legend.id)
				.on('click', function() {
					events.call(
						'showTooltip',
						this,
						{
							data: {
								specific: 'legend'
							},
							fix: true,
							tooltipClasses: tooltipClasses !== undefined ? tooltipClasses : defaultTooltipClasses,
							x: d3.event.pageX,
							y: d3.event.pageY - (tooltipHeight ? tooltipHeight : 55),
							showCallback: function() {
								d3
									.select('#' + legend.id)
									.classed('clicked', true);
							}
						}
					);
				});

			legend.initialized = true;
			return legend.initialized;
		};

		legend.initTooltip = function(Tooltip) {
			tooltip = legendTooltip(Tooltip, legend, d3);
		};

		legend.getTooltipWidgets = function() {
			return tooltip.widgets();
		};

		legend.scaling = function(_) {
			if (!arguments.length) {
				return nodeSizeFactor;
			}

			nodeSizeFactor = _;

			if (callback) {
				callback(nodeSizeFactor, module);
			}

			return legend;
		};

		legend.getTooltipData = function() {
			return tooltip.getTooltipData();
		};

		// update elements
		legend.update = function(width, height, nodeRadius, scaleFactor) {
			var l = d3.select('#' + legend.id);

			if (scaleFactor) {
				scale = scaleFactor;
			}
			minR = nodeRadius.range()[0] * nodeSizeFactor * scale;
			maxR = nodeRadius.range()[1] * nodeSizeFactor * scale;
			minVal = nodeRadius.domain()[0];
			maxVal = nodeRadius.domain()[1];

			l.attr('transform', 'translate(' + (width - 9) + ',' + (height - vOffset - 9) + ')');

			l
				.selectAll('.bubble-legend-min')
				.selectAll('.bubble-legend-circle')
				.attr('cx', -maxR)
				.attr('cy', -minR)
				.attr('r', minR);

			l
				.selectAll('.bubble-legend-min')
				.selectAll('.bubble-legend-value, .bubble-legend-value-bg')
				.attr('x', -maxR)
				.attr('y', -2 * minR)
				.attr('font-size', Math.min(maxFontSize, Math.ceil(maxR)) - 1 + 'px')
				.text(
					valType === 'float'
						? numFormat.format(minVal, 'float', false)
						: numFormat.format(minVal, 'int')
				);

			l
				.selectAll('.bubble-legend-max')
				.selectAll('.bubble-legend-circle')
				.attr('cx', -maxR)
				.attr('cy', -maxR)
				.attr('r', minVal === maxVal ? 0 : maxR); // hide the max circle when the min and max values are the same

			l
				.selectAll('.bubble-legend-max')
				.selectAll('.bubble-legend-value')
				.attr('x', -maxR)
				.attr('y', -2 * maxR)
				.attr('font-size', Math.min(maxFontSize, Math.ceil(maxR)) - 1 + 'px')
				.text(function() {
					if (minVal === maxVal) {
						return ''; // hide the max value when the min and max values are the same
					} else {
						return valType === 'float'
							? numFormat.format(maxVal, 'float', false)
							: numFormat.format(maxVal, 'int')
					}
				});

			l
				.selectAll('.bubble-legend-label')
				.attr('x', -2 * maxR - labelOffset)
				.attr('y', -maxR)
				.attr('font-size', maxFontSize + 'px');

			if (active) {
				legend.show();
			}
		};

		// update legend label
		legend.updateLabel = function(caption) {
			d3
				.select('#' + legend.id)
				.selectAll('.bubble-legend-label')
				.text(caption);
		};

		// show node within the legend
		legend.showNode = function(nodeData, nodeRadius) {
			if (nodeData === undefined || nodeData === null || isNaN(nodeData)) {
				return;
			}

			var l = d3.select('#' + legend.id);

			l
				.selectAll('.bubble-legend-value, .bubble-legend-value-bg')
				.attr('opacity', 0);

			l
				.select('.bubble-legend-node')
				.attr('opacity', 1);

			l
				.selectAll('.bubble-legend-node .bubble-legend-circle')
				.attr('cx', -maxR)
				.attr('cy', -nodeRadius(nodeData) * nodeSizeFactor * scale)
				.attr('r',
					nodeRadius.domain()[0] === nodeRadius.domain()[1]
						? maxR // use maxR when the min and max domain values are the same
						: nodeRadius(nodeData) * nodeSizeFactor * scale
				);

			l
				.selectAll('.bubble-legend-node .bubble-legend-value')
				.attr('x', -maxR)
				.attr('y', -2 * nodeRadius(nodeData) * nodeSizeFactor * scale)
				.attr('font-size', Math.min(maxFontSize, Math.ceil(maxR)) - 1 + 'px')
				.text(
					valType === 'float'
						? numFormat.format(nodeData, 'float', false)
						: numFormat.format(nodeData, 'int')
				)
				.attr('opacity', 1);
		};

		// hide node within the legend
		legend.hideNode = function() {
			var l = d3.select('#' + legend.id);

			l
				.selectAll('.bubble-legend-value, .bubble-legend-value-bg')
				.attr('opacity', 1);

			l
				.select('.bubble-legend-node')
				.attr('opacity', 0);
		};

		// hide legend values
		legend.hideValues = function() {
			d3
				.select('#' + legend.id)
				.selectAll('.bubble-legend-value, .bubble-legend-value-bg')
				.text('');

			this.hideNode();
		};

		// show legend
		legend.show = function() {
			d3
				.select('#' + legend.id)
				.attr('opacity', 1);
		};

		// hide legend
		legend.hide = function() {
			d3
				.select('#' + legend.id)
				.attr('opacity', 0);
		};

		// (de)activate legend
		legend.activate = function(a) {
			active = a;
		};

		// remove legend
		legend.remove = function() {
			d3
				.select('#' + legend.id)
				.remove();

			legend.initialized = false;
		};

		// set vertical offset for the legend
		legend.setVerticalOffset = function(offset) {
			vOffset = offset;
		};

		d3wl.rebind(legend, events, 'on');

		return legend;
	}
});
